export const UPDATE_PACKAGE = {
    REQUEST: 'PACKAGE.UPDATE_RELATED_PACKAGE.UPDATE_PACKAGE.REQUEST',
    SUCCESS: 'PACKAGE.UPDATE_RELATED_PACKAGE.UPDATE_PACKAGE.SUCCESS',
    FAILED: 'PACKAGE.UPDATE_RELATED_PACKAGE.UPDATE_PACKAGE.FAILED',
};

export const RESET_ERROR = 'PACKAGE.UPDATE_RELATED_PACKAGE.RESET_ERROR';

export const CLEAR_STATE = 'PACKAGE.UPDATE_RELATED_PACKAGE.CLEAR_STATE';
